import { Controller } from "@hotwired/stimulus"

/**
 * Keeps chrome outside the Home panel frame (the header's Library control) in
 * step with the panel on screen, since a frame swap never re-renders it (#1913).
 */
export default class extends Controller<HTMLElement> {
  static values = { key: String }

  declare readonly keyValue: string

  sync(event: CustomEvent<{ key: string }>) {
    if (event.detail.key === this.keyValue) {
      this.element.setAttribute("aria-current", "page")
    } else {
      this.element.removeAttribute("aria-current")
    }
  }
}
